export const environment = {
  production: true,
  apiUrl: 'https://api.dev.kletterwald-marburg.experience-solutions.de',
  mockApi: false,
  googleMaps: {
    apiKey: '',
    center: { lat: 51.165691, lng: 10.451526 },
    zoom: 6,
  },
};
